import { get, post } from "@/shared/api/api-client";

export class NotificationsService {
    async getAll() {
        return await get(`${PUBLIC_API_URL}/notifications`);
    }

    async getUnread() {
        return await get(`${PUBLIC_API_URL}/notifications/unread`);
    }

    async markAllAsReaden() {
        return await post(`${PUBLIC_API_URL}/notifications/read_all`);
    }
}